// 用户答题模块
export default {
  UserAnswer: {
    YouHaveAlreadyAnswered: 'You have already answered before',
    Question: 'Question',
    DoYouWantToContinue: 'Do you want to continue with the previous answer',
    PreviewOrPrint: 'Preview or Print',
    ReAnswerQuestions: 'Re-answer questions',
    ContinueAnsweringQuestions: 'Continue answering questions',
    TheQuestionnaireWillBeOpen: 'This questionnaire will be open. Please reopen this page when you arrive!',
    EnterQuestionnairePassword: 'Please enter the questionnaire password',
    EnterPassword: 'Please enter the password',
    Determine: 'Determine',
    ShareTo: 'Share to',
    ClickToView: 'Click to view',
    Statistics: 'Statistics',
    ShareOnWeChatMoments: 'Share on WeChat Moments',
    WantToContinue: 'Do you want to continue answering the question',
    NoActionTaken: 'If there is no operation for a long time, the system will automatically submit the answer',
    SubmitTo: 'Submit to',
    YouHaveLeftTheExam: 'You have left the questionnaire',
    Times: 'Times',
    Leave: 'Leaving',
    WillBeForcedToSubmitThePaper: 'will result in mandatory submission',
    NeedToOpenOnWeChat: 'You need to open it on WeChat to participate',
    ScanQRCodeUsingWeChat: 'Scan the QR code below using WeChat',
    CopyThisPageAddress: 'You can copy the address of this page and open it by sending a message on WeChat',
    WeChatLoginRequired: 'You can only participate after logging in on WeChat',
    OneClickLogin: 'One click login',
    Loading: 'Loading...',
    RateTheOptions: 'Please rate the options',
    SelectOptions: 'Please select an option',
    SelectDate: 'Please select a date',
    SortAllOptions: 'Please sort all options',
    SelectedPosition: 'Please select a location',
    EnsureCompleteAnswers: 'Please ensure that the answer is complete',
    Timing: 'Please select a time',
    ChooseAnOption: 'Please select an option',
    CheckTheAnswers: 'Please check the answer',
    InputContent: 'Please enter content',
    UploadFiles: 'Please upload the file',
    SelectSpecificGravity: 'Please select specific gravity',
    StatisticsPageToBeImproved: 'Statistics page to be improved',
    UploadFailed: 'Upload failed!',
    Submitting: 'Submitting...',
    Prompt: 'Prompt',
    TheAnswerIsNotRecorded: 'Currently on the preview page, the answer will not be recorded.',
    IsOver: "It's over",
    NothingInTheWorld: "There's nothing here",
    Staging: 'Staging',
    ScanQRCodeToAnswerQuestions: 'Scan QR code to answer questions',
    Report: 'Report',
    DongfangAixueProvidesSupport: 'Supported by SurverTree',
    Print: 'Print',
    DataPreparationInProgress: 'Data preparation is underway and is expected to be completed in 5 minutes. go to',
    CanViewProgress: 'to view progress',
    MyDownload: 'My download',
    QuotaIsFull: 'Quota is full',
    SuccessfullyStaged: 'Successfully staged',
    PleaseEnter: 'Enter',
    Other: 'Other',
    PleaseSelect: 'Please select',
    Small: 'Small',
    Middle: 'Middle',
    TotalSpecificGravity: 'Total Specific Gravity',
    Big: 'Big',
    Year: 'Year',
    Month: 'Month',
    Day: 'Day',
    GetLocation: 'Click to obtain geographical location',
    YourLocation: 'Your location',
    SearchAddress: 'Enter keyword search address',
    Clear: 'Clear',
    SelectAProvince: 'Please select a province',
    SelectACity: 'Please select a city',
    SelectADistrict: 'Please select a district/county',
    DetailedAddress: 'Detailed address',
    UploadFileImages: 'Upload file images',
    UploadFilesWithin10M: 'Choose to upload files (within 10MB)',
    TheFileSizeCannotExceed10MB: 'The size of the uploaded file cannot exceed 10MB!',
    MaximumNumberOfTimes: 'The maximum number of file uploads has been reached',
    FailedToUploadFile: 'Failed to upload file',
    SelectCascadingOption: 'Please select cascading option',
    SelectTheFollowingImage: 'Please select the following image',
    MaximumSelection: 'Maximum selection of options',
    Options: 'Options',
    MinimalSelection: 'Minimal selection of options',
    CheckTheAnswers: 'Please check the answer',
    OnlineQuestionnaire: 'Online questionnaire:',
    ExplanationScores: 'Explanation of scores:',
    ExplanationScoresA: 'If your score on a scale is',
    ExplanationScoresB: 'you have a mild preference for',
    ExplanationScoresC: 'dimension but  you are essentially well balanced',
    ExplanationScoresD: 'you have a moderate preference for',
    ExplanationScoresE: 'dimension of the scale  and will learn more easily in a teaching environment which favors that dimension.',
    ExplanationScoresF: 'you have a strong preference for ',
    ExplanationScoresG: 'dimension of the scale.  You may have real difficulty learning in an environment which does not support that  preference.'
  },
};